import { TemplatePage } from './types';

const zoomBackgroundPage: TemplatePage = {
  header: {
    color: '#E6E6E6',
    icon: 'images/video-templates/virtual-backgrounds.jpg',
    title: 'Zoom Video Backgrounds',
    title_meta: '50+ Free Downloadable Zoom Video Backgrounds',
    description_meta:
      'Jazz up your next online meeting with these ready-to-use custom Zoom video backgrounds.',
    description:
      'Jazz up your next online meeting with these ready-to-use custom Zoom video backgrounds. Pick a virtual ' +
      'background template of your choice, then simply download it and use the background during your conference call.'
  },
  footer: {
    category: 'Zoom Backgrounds',
    description:
      'With the help of Wave.video’s broad range of ready-made Zoom video backgrounds, you will be able to ' +
      'create awesome virtual backgrounds for your online video calls in a matter of minutes. All the backgrounds ' +
      'are easy and free to personalize to suit your branding.'
  },
  content: [
    {
      type: 'templates',
      title: 'Zoom Video Backgrounds',
      search: { category: '/Use-Cases/Virtual-Backgrounds' }
    },
    {
      type: 'stocks',
      title: 'zoom backgrounds',
      search: { name: 'zoom backgrounds' }
    },
    { type: 'calendar' }
  ]
};

export default zoomBackgroundPage;
